export const CERTIFICATION_RESULT_FILE_ACCEPT = '.pdf,.jpg,.jpeg,.png,.gif,.webp,.xls,.xlsx,.csv'

/** PDF certificate download — enable per brand deploy via ENV. */
export const CERTIFICATE_PDF_DOWNLOAD_ENABLED = process.env.VUE_APP_CERTIFICATE_PDF_DOWNLOAD_ENABLED === 'true'

function sanitizeFilenamePart(value) {
  return (value || '').trim().replace(/[/\\?%*:|"<>]/g, '_')
}

export function getCertificationResultFileExtension(originalName) {
  if (!originalName) return 'pdf'

  const lastDot = originalName.lastIndexOf('.')
  if (lastDot <= 0) return 'pdf'

  return originalName.slice(lastDot + 1)
}

export function buildCertificationDownloadFilename(user, extension) {
  const fullName = sanitizeFilenamePart(`${user?.firstName || ''} ${user?.lastName || ''}`.trim())
  const base = fullName ? `Certyfikat_${fullName}` : 'Certyfikat'

  if (!extension) return base

  const normalizedExtension = extension.startsWith('.') ? extension.slice(1) : extension
  return `${base}.${normalizedExtension}`
}

export function buildMediaObjectDownloadUrl(baseURL, contentUrl) {
  const base = String(baseURL || '').replace(/\/+$/, '')
  const path = String(contentUrl || '').replace(/^\/+/, '')
  return `${base}/${path}`
}

export function parseContentDispositionFilename(contentDisposition) {
  if (!contentDisposition) return null

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition)
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1])
  }

  const match = /filename="?([^";\n]+)"?/i.exec(contentDisposition)
  return match ? match[1].trim() : null
}

export function triggerBlobDownload(blob, filename) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
    return
  }

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => {
    window.URL.revokeObjectURL(url)
  }, 2000)
}

export function buildCertificationResultForm(slot) {
  return {
    attendance: slot.attendance === null ? true : slot.attendance,
    passed: slot.passed === null ? true : slot.passed,
    justification: slot.justification,
    resultFile: slot.resultFile || null,
    pendingFile: null,
    removeResultFile: false,
  }
}

export function canDeleteCertificationEnrolment(slot) {
  return !!(slot?.enrolmentId && !slot?.hasInvoice)
}

export function buildSetAttendancePayload(certificationId, enrolmentId, resultForm) {
  const payload = {
    certificationId,
    id: enrolmentId,
    attendance: resultForm.attendance,
    passed: resultForm.passed,
    justification: resultForm.justification,
  }

  if (resultForm.removeResultFile) {
    payload.removeResultFile = true
  }
  if (resultForm.resultFileIri) {
    payload.resultFile = resultForm.resultFileIri
  }

  return payload
}
